module.exports = __webpack_public_path__ + "img/icon-rug.87478c65.png";